// extracted by mini-css-extract-plugin
export var cartIcon = "_pa-0";
export var cartIconContainer = "_pa-1";